import moment from 'moment';
import c from '@/components/Core/constants.js'
function EnumerateDaysBetweenDates(startDate, endDate) {
	var now = startDate,
		dates = [];
	while (now.isSameOrBefore(endDate)) {
		dates.push(now.format('MM/DD/YYYY'));
		now.add(1, 'days');
	}
	return dates;
}

function getDayFormat(date) {
	return moment(date).format('dddd').charAt(0);
}
function IsCurrentDate(date) {
	if (moment(date).format('MM/DD/YYYY') == moment().format('MM/DD/YYYY')) {
		return true;
	} else {
		return false;
	}
}
window.trim = () => {
	var inputs = document.getElementsByTagName('input');
	for (var i = 0; i < inputs.length; i++) {
		if (inputs[i].type == 'text') {
			$('.fc-cv-search-btn').css('visibility', 'visible');
			inputs[i].onkeyup = function() {
				this.value = this.value.replace(/^\s+/, '');
				if (this.value.length > 0) {
					$('.fc-cv-search-btn').css('visibility', 'visible');
				} else {
					$('.fc-cv-search-btn').css('visibility', 'hidden');
				}
			};
		}
	}
};
const WeekDayRender = (year, month) => {
	const datefrom = moment(`${year}-${month}-01`).startOf('month').format('MM/DD/YYYY');
	const dateTo = moment(`${year}-${month}-01`).endOf('month').format('MM/DD/YYYY');

	const week_start_date = moment(datefrom).startOf('week').format('MM/DD/YYYY');
	const week_end_date = moment(dateTo).endOf('week').format('MM/DD/YYYY');
	var fromDateDiffList = EnumerateDaysBetweenDates(moment(week_start_date), moment(datefrom).add(-1, 'days'));
	var toDateDiffList = EnumerateDaysBetweenDates(moment(dateTo).add(1, 'days'), moment(week_end_date));

	let currentMonthDateList = EnumerateDaysBetweenDates(moment(datefrom), moment(dateTo));
	var dateArrayList = fromDateDiffList.concat(currentMonthDateList).concat(toDateDiffList);

	const header = `
  <div class="fc-ob-week-day-render-container">
    <table class="fc-ob-week-day-render">
      <tr>
  `;

	let tds = `
  <td  rowspan="2" style="padding-top: 15px;">
    <div class="fc-ob-cell" style="background-image:url('${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/search_background.png')">
      <div class="fc-cv-search-wrapper"  style="height:31px">
        <input type="text" onkeyup="trim()" placeholder="Search employees" class="fc-cv-search-input">
        <i class="fa fa-search fc-cv-search-btn"></i>
        <span class="fc-cv-remove-btn cross-img-span" > <img  class="cross-img" src='${c.CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_close.svg'></span>
      </div>
	</div>
	<div style="display: None;margin-top: -12px;" id='no_of_emp_remainder' style="margin-top: -15px;">
	<div style="display: inline-block;margin-right: 5px" id='no_of_emp_remainder_num'></div>
	<div style="display: inline-block"><a class="emp_rem_selectAll" style="font-size: 12px;font-weight: 600"> All </a></div>/
	<div style="display: inline-block"><a class='emp_rem_selectNone' style="font-size: 12px;font-weight: 600"> None </a></div>
</div>
  </td>`;
	for (var i = 0; i < dateArrayList.length; i++) {
		if (!IsCurrentDate(dateArrayList[i])) {
			let fontColor = '#929291';
			if (currentMonthDateList.includes(dateArrayList[i])) {
				fontColor = '#232323';
			}
			tds +=
				`<td><div class="fc-ob-cell"><span>${getDayFormat(dateArrayList[i])}</span></div>
             <div class="fc-ob-cell"  style="color:` +
				fontColor +
				`;font-weight: 600;padding-top: 5px;padding-left:10px"><span>${moment(dateArrayList[i]).format(
					'D'
				)}</span></div></td>`;
		} else {
			tds += `<td><div class="fc-ob-cell" style="margin-bottom: -4px;"><span>${getDayFormat(
				dateArrayList[i]
			)}</span></div>
             <div class="fc-ob-cell current-date" style="font-weight: 600;;padding-top: 5px;padding-left: 12px;"><span>${moment(
					dateArrayList[i]
				).format('D')}</span></div></td>`;
		}
	}

	const footer = `
      </tr>
    </table>
  </div>
  `;

	return header + tds + footer;
};

export default WeekDayRender;



// WEBPACK FOOTER //
// ./src/components/ESSProfile/Timesheets/Calender/CustomViews/Monthly/WeekDayRender/WeekDayRender.js